export const AppConfig =  {
    "editor_backgrounds": [
        {
                "name" : "White",
                "type" : "solidcolor",
                "background_color": "#ffffff",
                "grid_color": "#000000",
                "grid_opacity": "0.1"
        },
        {
            "name" : "Gray",
            "type" : "solidcolor",
            "background_color": "#6E6E6E",
            "grid_color": "#ffffff",
            "grid_opacity": "0.1"
        },
        {
            "name" : "Black",
            "type" : "solidcolor",
            "background_color": "#000000",
            "grid_color": "#ffffff",
            "grid_opacity": "0.1",
        },
        {
            "name" : "darkgray",
            "type" : "gradient",
            "file_url": "gradient2.hdr",
            "grid_color": "#ffffff",
            "grid_opacity": "0.2",
            "background_color_css" :"rgb(67,67,69)",
            "background_gradient_css" :  "linear-gradient(180deg, rgba(67,67,69,1) 0%, rgba(146,147,151,1) 100%)"
        },
        {
            "name" : "lightgray",
            "type" : "gradient",
            "file_url": "gradient1.hdr",
            "grid_color": "#000000",
            "grid_opacity": "0.1",
            "background_color_css" :"rgb(171,172,176)",
            "background_gradient_css" :  "linear-gradient(180deg, rgba(171,172,176,1) 0%, rgba(228,228,230,1) 100%)"
        }
    ],
    "editor_settings": {
        "maximumAngleCamera" : 3,
        "minimumAngleCamera" : -0.5
    }
};